function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  y: 0.206894,
  width: 37,
  height: 37,
  rx: 7,
  fill: "#7611F7"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  opacity: 0.3,
  x: 9,
  y: 9.20689,
  width: 9,
  height: 9,
  rx: 1.5,
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.1333 10.7069C19.1333 9.87847 19.8049 9.20689 20.6333 9.20689H26.5C27.3284 9.20689 28 9.87847 28 10.7069V16.5736C28 17.402 27.3284 18.0736 26.5 18.0736H20.6333C19.8049 18.0736 19.1333 17.402 19.1333 16.5736V10.7069ZM9 20.8402C9 20.0118 9.67157 19.3402 10.5 19.3402H16.3667C17.1951 19.3402 17.8667 20.0118 17.8667 20.8402V26.7069C17.8667 27.5353 17.1951 28.2069 16.3667 28.2069H10.5C9.67157 28.2069 9 27.5353 9 26.7069V20.8402ZM20.6333 19.3402C19.8049 19.3402 19.1333 20.0118 19.1333 20.8402V26.7069C19.1333 27.5353 19.8049 28.2069 20.6333 28.2069H26.5C27.3284 28.2069 28 27.5353 28 26.7069V20.8402C28 20.0118 27.3284 19.3402 26.5 19.3402H20.6333Z",
  fill: "white"
});

function SvgDashIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 38,
    viewBox: "0 0 37 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashIcon);
export default __webpack_public_path__ + "static/media/dash-icon.8ff521eb.svg";
export { ForwardRef as ReactComponent };